import de from './translations/de';
import en from './translations/en';
import es from './translations/es';
import uk from './translations/uk';
export default
{
    de,
    en,
    es,
    uk
};